// extracted by mini-css-extract-plugin
export default {"menuList":"Menu_menuList__+R6Mt"};